<div class="row ng-scope">
  <div class="col-12">
    <div class="row form-group">
      <label class="control-label col-2">{{'Đơn vị' | translate}}<span class="cred">(*)</span></label>
      <div class="col-4">
        <ng-select #slChiNhanh
                   class="twcollong"
                   [tabIndex]="1"
                   [openOnEnter]="false"
                   [items]="dschinhanhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   (change)="changeChiNhanh($event)"
                   [(ngModel)]="doituongSelect.DonViId">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <label class="control-label col-2">{{'Kho' | translate}}<span class="cred">(*)</span></label>
      <div class="col-4">
        <ng-select #slKho
                   class="twcollong"
                   [tabIndex]="2"
                   [openOnEnter]="false"
                   [items]="dskhohangs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.KhoHangId">
          <ng-template ng-footer-tmp>
            <a (click)="AddKhoHang()"><em class="mr-2 far fa-plus-square" style="color:red;font-weight:bold"></em>Thêm mới</a>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

    </div>
    <div class="row form-group">
      
      <label class="control-label col-2">{{'Ngày nhập' | translate}}<span class="cred">(*)</span></label>
      <div class="col-2">
        <kendo-dateinput tabindex="4" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Ngay"></kendo-dateinput>
      </div>
    </div>

    





    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ghi chú</label>
      <div class="col-10">
        <textarea type="text" tabIndex="10" rows="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu"></textarea>
      </div>
    </div>



    <div class="row">
      <button style="float:left" class="btn btn-info btn-bloc" (click)="ThemSanPham()">
        {{'Thêm sản phẩm' | translate}}
      </button>
    </div>


    <div class="row">
      <table class="table table-striped table-bordered table-hover table-condensed">
        <thead>
          <!--<thead>-->
          <tr>
            <th style="width:130px;text-align:center;background-color:#f3f8fc">Sản phẩm</th>
            <th style="width:100px;text-align:center;background-color:#f3f8fc">Đơn vị</th>
            <th style="width:110px;text-align:center;background-color:#f3f8fc">Đơn giá</th>
            <th style="width:110px;text-align:center;background-color:#f3f8fc">Số lượng</th>
            <th style="width:110px;text-align:center;background-color:#f3f8fc">Nhà cung cấp</th>
            <th style="width:100px;text-align:center;background-color:#f3f8fc"></th>
            
          </tr>


        </thead>
        <tbody style="max-height: 180px;">
          <tr *ngFor="let u of doituongSelect.ChiTiets; let i = index">
            <td style="width:130px">
              <ng-select #slSanPham
                          [dropdownPosition]="u.showpopup"
                         class="twcollong"
                         labelForId="{{i}}_1_1"
                         [openOnEnter]="false"
                         [items]="dssanphams"
                         bindValue="Id"
                         bindLabel="Ten"
                         notFoundText="Không có dữ liệu"
                         [searchFn]="comboSearchFn2"
                         (change)="changeSanPham($event, i)"
                         [(ngModel)]="u.SanPhamId">
                <ng-template ng-footer-tmp>
                  <a (click)="AddSanPham()"><em class="mr-2 far fa-plus-square" style="color:red;font-weight:bold"></em>Thêm mới</a>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <div class="rTableRow">
                    <div class="rTableCell_1">{{item.Ten}}</div>
                  </div>
                </ng-template>
              </ng-select>
            </td>
            <td style="width:100px">
              <ng-select #slDonViTinh
                          [dropdownPosition]="u.showpopup"
                         class="twcollong"
                         labelForId="{{i}}_1_2"
                         [disabled]="true"
                         [openOnEnter]="false"
                         [items]="dsdonvitinhs"
                         bindValue="Id"
                         bindLabel="Ten"
                         notFoundText="Không có dữ liệu"
                         [searchFn]="comboSearchFn2"
                         [(ngModel)]="u.DonViTinhId">
                <ng-template ng-option-tmp let-item="item">
                  <div class="rTableRow">
                    <div class="rTableCell_1">{{item.Ten}}</div>
                  </div>
                </ng-template>
              </ng-select>
            </td>
            <td style="width:100px">
              <input id="{{i}}_1_3" class="form-control"
                     maxlength="20"
                     currencyMask
                     [(ngModel)]="u.DonGia"
                     name="value"
                     [placeholder]="'Đơn giá'"
                     [options]="ngxCurrencyOptions" autocomplete="off" />
            </td>
            <td style="width:100px">
              <input  id="{{i}}_1_4" class="form-control"
                     maxlength="20"
                     currencyMask
                     [(ngModel)]="u.SoLuong"
                     name="value"
                     [placeholder]="'Số lượng'"
                     [options]="ngxCurrencyOptions" autocomplete="off" />
            </td>
            <td style="width:100px">
              <ng-select #slNhaCungCap
                          [dropdownPosition]="u.showpopup"
                         class="twcollong"
                         labelForId="{{i}}_1_5"
                         [openOnEnter]="false"
                         [items]="dsnhacungcaps"
                         bindValue="Id"
                         bindLabel="Ten"
                         notFoundText="Không có dữ liệu"
                         [searchFn]="comboSearchFn2"
                         [(ngModel)]="u.NhaCungCapId">
                <ng-template ng-footer-tmp>
                  <a (click)="AddNhaCungCap()"><em class="mr-2 far fa-plus-square" style="color:red;font-weight:bold"></em>Thêm mới</a>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <div class="rTableRow">
                    <div class="rTableCell_1">{{item.Ten}}</div>
                  </div>
                </ng-template>
              </ng-select>
            </td>

            <td style="width:100px;text-align:center">
              <a class="mb-1 far fa-trash-alt ng2-smart-action ng2-smart-action-custom-custom ng-star-inserted" (click)="deleterow(i)"> {{'Xóa' | translate}}</a>
            </td>

          </tr>
        </tbody>
      </table>


    </div>


    <!--<div class="row form-group"  *ngIf="tudanhsach==1">
    <label class="control-label col-3">{{'Nội dung tư vấn' | translate}}</label>
    <div class="col-9">
      <ejs-richtexteditor style="background-color:white" height='250px' #toolsRTE id='alltoolRTE_ch' [toolbarSettings]='tools' [showCharCount]='true' [(value)]='doituongSelect.NoiDungTuVan'
                          [maxLength]='maxLength' [fileManagerSettings]='fileManagerSettings' [quickToolbarSettings]='quickToolbarSettings'
                          (actionBegin)='handleFullScreen($event)' (actionComplete)='actionCompleteHandler($event)'>
      </ejs-richtexteditor>

    </div>
  </div>-->


    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ngày tạo</label>
      <div class="col-4" style="font-weight:bold">
        <!--<kendo-dateinput tabindex="13" style="width:100%;" disabled="disabled" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Created"></kendo-dateinput>-->
        {{doituongSelect.Created | date:'dd/MM/yyyy HH:mm:ss'}}
      </div>
      <label class="control-label col-2 ng-binding">Người Tạo</label>
      <div class="col-4">
        <input type="text" tabIndex="14" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
      </div>
    </div>


    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ngày sửa</label>
      <div class="col-4" style="font-weight:bold">
        <!--<kendo-dateinput tabindex="13" style="width:100%;" disabled="disabled" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Modified"></kendo-dateinput>-->
        {{doituongSelect.Modified | date:'dd/MM/yyyy HH:mm:ss'}}
      </div>
      <label class="control-label col-2 ng-binding">Người sửa</label>
      <div class="col-4">
        <input type="text" tabIndex="14" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.ModifiedBy">
      </div>
    </div>



  </div>

</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThai" />
        <span class="fa fa-check"></span> {{'Hoạt động' | translate}}
      </label>
    </div>-->
  </div>

  <div class="">
    <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
    <button style="float:left !important" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
  </div>

</div>


<!--<div id='target' class="control-section">
  <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
              [target]='target' [width]='dialogWidth'>
    <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                     [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                     [contextMenuSettings]='contextMenuSettings'
                     [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)">
    </ejs-filemanager>
  </ejs-dialog>
</div>-->
<bs-modal #mdKhoHang class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới kho hàng</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdKhoHang.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-khohangedit #dtekhohangedit (save)="saveModal_Kho($event)"></app-danhmuc-khohangedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdNhaCungCap class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới nhà cung cấp</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdNhaCungCap.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-nhacungcapedit #dtenhacungcapedit (save)="saveModal_NhaCungCap($event)"></app-danhmuc-nhacungcapedit>
  </bs-modal-body>
</bs-modal>


<bs-modal #mdSanPham class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới sản phẩm</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdSanPham.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-sanphamedit #dtesanphamedit (save)="saveModal_SanPham($event)"></app-danhmuc-sanphamedit>
  </bs-modal-body>
</bs-modal>

